import i18n from '../../plugins/i18n';

const configurations = {
  headers: [
    { text: 'Datum', value: 'date' },
    { text: 'Antragsteller', value: 'applicant' },
    { text: 'Produktgruppe', value: 'product' },
    { text: 'Anschlussadresse', value: 'address' },
    { text: i18n.t('sealing.sealing_reason'), value: 'sealingReason' },
    { text: 'zul. bearbeitet von', value: 'lastChangedBy' },
  ],
};

export const getSealingTableConfig = (configName) =>
  JSON.parse(JSON.stringify(configurations[configName]));
